<div class="file-download">
  <i class="fas fa-download file-download-icon"></i>
  <!-- loading -->
  @if (loadingModel.isLoading) {
    <span class="ui-loading" [model]="loadingModel"></span>
  } @else {
    <!-- button -->
    <button class="btn file-download-btn" (click)="onClickBtn()">
      <span class="file-download-text">{{'stations.form.label.download_file' | translate}}</span>
    </button>
    <!-- feedback -->
    @if (msgType === MSG_TYPE_ENUM.ERROR) {
      <span class="alert alert-danger file-download-feedback">{{'component.downloadFile.error' | translate}}</span>
    }
  }
  <!-- content -->
</div>